<template>
  <div class="calendar-box">
    <div class="calendar-title-box">
      <h5 class="common-h5">维保日历</h5>
      <div class="block">
        <el-date-picker
          v-model="value2"
          type="month"
          @change="chooseDate"
          placeholder="选择月"
          size="mini"
        >
        </el-date-picker>
      </div>
    </div>
    <ul class="calendar-box-week">
      <li>周一</li>
      <li>周二</li>
      <li>周三</li>
      <li>周四</li>
      <li>周五</li>
      <li>周六</li>
      <li>周日</li>
    </ul>
    <ul class="calendar-main">
      <li v-for="(item, index) in dateList" :key="index" class="day-box">
        <div class="day-title">
          <!-- <img src="../../../assets/icon/workorder.png" alt="" /> -->
          <span class="month-mark" v-if="item.text">{{ item.text }}</span>
          <span>{{ item.day }}日</span>
        </div>
        <div class="day-tag">
          <p class="plan" @click="handleClick(item, 1)">
            <span>计划</span>
            <span
              >{{
                monthlyCalendarObj[item.date]
                  ? monthlyCalendarObj[item.date].maintainPlanAmount
                  : ""
              }}台</span
            >
          </p>
          <p class="maintenanced" @click="handleClick(item, 2)">
            <span>已保养</span>
            <span
              >{{
                monthlyCalendarObj[item.date]
                  ? monthlyCalendarObj[item.date].maintainCompleteAmount
                  : ""
              }}台</span
            >
          </p>
          <p class="serviced" @click="handleClick(item, 3)">
            <span>已维修</span>
            <span
              >{{
                monthlyCalendarObj[item.date]
                  ? monthlyCalendarObj[item.date].repairCompleteAmount
                  : ""
              }}台</span
            >
          </p>
        </div>
      </li>
    </ul>
    <LiftDetail v-if="showLiftDetail" :getDetailParams="getDetailParams" @cancel="showLiftDetail=false"></LiftDetail>
  </div>
</template>

<script>
import { getMonthlyCalendar } from "@/api/UserConsole";
import LiftDetail from "./LiftDetail";
export default {
  name: "MaintenanceCalendar",
  components: {
    LiftDetail
  },
  data() {
    return {
      statisticsDate: "",
      monthlyCalendar: [],
      monthlyCalendarObj: {},
      haveDay: [],
      date: new Date(),
      dateList: [],
      value2: new Date(),
      showLiftDetail: false,
      getDetailParams: {
        statisticsDate: '',
        statisticsType: ''
      }
    };
  },
  created() {
    this.getDateArr(this.date);
  },
  methods: {
    async getMonthlyCalendar(statisticsDate) {
      const res = await getMonthlyCalendar(statisticsDate);
      if (res.code === 200) {
        this.haveDay = [];
        this.monthlyCalendar = [];
        this.monthlyCalendarObj = {};
        res.data.forEach((item) => {
          this.haveDay.push(item.statisticsDate);
          this.monthlyCalendarObj[item.statisticsDate] = item;
        });
        this.monthlyCalendar = res.data;
      }
    },
    dianji() {},
    handleClick(item, index) {
      this.getDetailParams = {
        statisticsDate: item.date,
        statisticsType: index,
        pageIndex: 1,
        pageSize: 1000
      };
      this.$nextTick(()=>{
        this.showLiftDetail = true
      })
    },
    formatDay(num) {
      let str = "";
      switch (num) {
        case 1:
          str = "一";
          break;
        case 2:
          str = "二";
          break;
        case 3:
          str = "三";
          break;
        case 4:
          str = "四";
          break;
        case 5:
          str = "五";
          break;
        case 6:
          str = "六";
          break;
        case 7:
          str = "七";
          break;
        case 8:
          str = "八";
          break;
        case 9:
          str = "九";
          break;
        case 10:
          str = "十";
          break;
        case 11:
          str = "十一";
          break;
        case 12:
          str = "十二";
          break;
        default:
          str = "";
      }
      return str + "月";
    },
    // 获取指定日期的前几后几天
    fungetdate(date, count, showTest) {
      let dd = new Date(date);
      const nowYear = dd.getFullYear();
      dd.setDate(dd.getDate() + count); //获取p_count天后的日期
      const y = dd.getFullYear();
      const m = dd.getMonth() + 1; //获取当前月份的日期
      const d = dd.getDate();
      const newDate =
        y + "-" + (m >= 10 ? m : "0" + m) + "-" + (d >= 10 ? d : "0" + d);
      let obj = {
        year: y,
        month: m,
        day: d,
        date: newDate,
      };

      if (nowYear != y && m == 1 && d == 1) {
        obj.text = `${y}年一月`;
      }
      if (showTest && count === -1) {
        obj.text = this.formatDay(m);
      } else if (showTest && count === 0) {
        obj.text = this.formatDay(m);
      }
      return obj;
    },
    getDateArr(date) {
      // 请求数据参数
      const params = {
        startDate: "",
        endDate: "",
      };

      const newDate = new Date(date);
      const nowYear = newDate.getFullYear();
      const nowMonth = newDate.getMonth() + 1;
      // 获取这个月的总天数
      const allDay = new Date(nowYear, nowMonth, 0).getDate();

      // 获取传入日期的一号几几年几月一号
      const firstDay =
        nowYear + "-" + (nowMonth >= 10 ? nowMonth : "0" + nowMonth) + "-01";
      const lastDay =
        nowYear + "-" + (nowMonth >= 10 ? nowMonth : "0" + nowMonth) + allDay;
      // 获取这个月份一号为周几
      const week = new Date(firstDay).getDay();

      // 根据周几判断出日期数组需要在前面添加上一个月的天数
      const pastNum = week - 1;

      params.startDate = this.fungetdate(firstDay, -pastNum).date;
      params.endDate = this.fungetdate(firstDay, 6 * 7 - pastNum).date;
      this.getMonthlyCalendar(params);

      // 获取真正展示的日历
      let trueArr = [];
      for (let i = pastNum; i > 0; i--) {
        if (i == 1) {
          trueArr.push(this.fungetdate(firstDay, -i, true));
        } else {
          trueArr.push(this.fungetdate(firstDay, -i));
        }
      }
      // 根据6 * 7方阵计算出后面需要补的所有日期
      for (let i = 0; i < 6 * 7 - pastNum; i++) {
        if (i == 0) {
          trueArr.push(this.fungetdate(firstDay, i, true));
        } else {
          trueArr.push(this.fungetdate(firstDay, i));
        }
      }
      this.dateList = trueArr;
    },
    chooseDate(val) {
      this.getDateArr(val);
    },
  },
};
</script>

<style lang="scss">
.calendar-box {
  margin-right: 20px;
  background-color: #ffffff;
  min-width: 1110px;
  .calendar-title-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 20px;
    border-bottom: 1px solid #e6e6e6;
    .el-input--mini .el-input__inner {
      padding-left: 30px;
    }
  }
  .el-calendar-table:not(.is-range) td.next,
  .el-calendar-table:not(.is-range) td.prev {
    pointer-events: none;
  }
  .el-calendar-table .el-calendar-day {
    height: 119px;
    width: 151px;
    padding: 0;
  }
  .day-box {
    font-size: 14px;
    display: flex;
    flex-direction: column;
    p {
      width: 112px;
      height: 18px;
      line-height: 18px;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      padding: 0 6px;
      margin-left: 28px;
      border: 1px solid #6236ff;
      margin-bottom: 6px;
      align-items: center;
    }
    .day-tag {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      flex: 1;
      p {
        cursor: pointer;
      }
    }
    .day-title {
      font-size: 16px;
      height: 22px;
      line-height: 22px;
      display: flex;
      align-items: center;
      margin: 10px 0;
      width: 112px;
      margin-left: 28px;
      padding: 0 4px;
      justify-content: flex-end;
      color: #333333;
      img {
        width: 16px;
        height: 15px;
        margin-right: 10px;
      }
      .month-mark {
        font-size: 12px;
        margin-right: 5px;
        background-color: #e6e6e6;
      }
    }
    .plan {
      color: #6236ff;
    }
    .maintenanced {
      color: #32c5ff;
      border-color: #32c5ff;
    }
    .serviced {
      color: #fa6400;
      border-color: #fa6400;
    }
    .maintenance {
      color: #e02020;
      border-color: #e02020;
    }
  }
  ul {
    display: flex;
    li {
      flex: 1;
    }
  }
  .calendar-main {
    margin: 0 20px;
    flex-wrap: wrap;
    border-right: 1px solid #e6e6e6;
    border-bottom: 1px solid #e6e6e6;
    li {
      border-top: 1px solid #e6e6e6;
      border-left: 1px solid #e6e6e6;
      padding-bottom: 2px;
    }
  }
  .calendar-box-week {
    padding-top: 20px;
    padding-bottom: 4px;
    margin: 0 20px;
    li {
      text-align: center;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #666666;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/UserConsole/components/MaintenanceCalendar.vue